import { defaultClient } from '@mint-sdk/api-core';
import z from 'zod';

import {
  activitySummaryResponseSchema,
  flightSummaryResponseSchema,
  mediaPlanSummaryResponseSchema,
} from '../shared/schemas/summary.js';

export const getMediaPlanSummaryQueryOptions = defaultClient.query({
  url: 'planning-service/media-lines/summary/media-plan/$mediaDataId/' as const,
  method: 'GET',
  responseSchema: mediaPlanSummaryResponseSchema,
  processResponse(data) {
    return data.data?.items[0];
  },
});

export const getActivitySummaryQueryOptions = defaultClient.query({
  url: 'planning-service/media-lines/summary/activity/$mediaDataId/' as const,
  method: 'GET',
  responseSchema: activitySummaryResponseSchema,
  processResponse(data) {
    return data.data?.items[0];
  },
});

export const getFlightSummaryQueryOptions = defaultClient.query({
  url: 'planning-service/media-lines/summary/flight-activity/$mediaDataId/' as const,
  method: 'GET',
  querySchema: z.object({
    flightVersionId: z.string().optional(),
  }),
  responseSchema: flightSummaryResponseSchema,
  processResponse(data) {
    return data.data?.items[0];
  },
  clientOptions: {
    request: {
      snakeCaseQueryParams: true,
    },
  },
});
